// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"899d4cea","543":"b7ade30a"}[chunkId] + ".chunk.css";
};